var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0011 74.1873C23.0011 45.8502 46.0741 23 74.407 23C102.74 23 125.813 45.8333 125.813 74.1873C125.813 86.2159 121.644 97.2774 114.664 106.012C105.032 118.108 90.3289 125.376 74.4059 125.376C58.483 125.376 43.7604 118.063 34.1406 106.012C27.1604 97.2785 23 86.2169 23 74.1873H23.0011Z",
    fill: "url(#paint0_linear_3927_17261)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7623 28.5801C42.3248 27.927 42.241 26.9368 41.5861 26.3756C40.9303 25.8155 39.9432 25.8905 39.3807 26.5426C38.8182 27.1957 38.8851 28.187 39.541 28.7481C40.1969 29.3082 41.2009 29.2321 41.7634 28.5801H41.7623Z",
    fill: "url(#paint1_linear_3927_17261)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0008 104.205C29.3574 103.422 28.9976 102.494 28.2112 102.139C27.4247 101.784 26.4972 102.132 26.1406 102.916C25.784 103.699 26.1289 104.633 26.9153 104.988C27.7018 105.343 28.6442 104.989 29.0008 104.206V104.205Z",
    fill: "url(#paint2_linear_3927_17261)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0008 89.2052C22.3574 88.4222 21.9976 87.4943 21.2112 87.1392C20.4247 86.7841 19.4972 87.1318 19.1406 87.9159C18.784 88.699 19.1289 89.6333 19.9153 89.9883C20.7018 90.3434 21.6442 89.9894 22.0008 89.2063V89.2052Z",
    fill: "url(#paint3_linear_3927_17261)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7157 98.4653C25.276 97.2341 24.7104 95.7767 23.4739 95.2188C22.2375 94.6608 20.7814 95.2071 20.221 96.4383C19.6606 97.6695 20.2019 99.1363 21.4383 99.6933C22.6748 100.251 24.1553 99.6954 24.7157 98.4642V98.4653Z",
    fill: "url(#paint4_linear_3927_17261)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3403 35.0537C37.2244 34.0286 37.0928 32.4709 36.0633 31.5906C35.0338 30.7102 33.4822 30.8275 32.5981 31.8526C31.714 32.8777 31.8201 34.4365 32.8496 35.3179C33.8791 36.1982 35.4573 36.0788 36.3413 35.0537H36.3403Z",
    fill: "url(#paint5_linear_3927_17261)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.037 52.7568V70.4779H32.9631V43.6532C32.9631 40.4167 35.5795 37.7948 38.806 37.7948H52.9175C54.9021 37.7948 56.7519 38.8053 57.8278 40.4778L60.0547 43.9399L60.307 43.7776L60.0547 43.9399C61.2407 45.7837 63.2804 46.8984 65.4695 46.8984H109.194C112.42 46.8984 115.037 49.5203 115.037 52.7568Z",
    fill: "url(#paint6_linear_3927_17261)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.493 70.551L124.462 70.6804L116.619 103.303C115.644 107.354 112.043 110.205 107.906 110.205H40.0931C35.9562 110.205 32.3551 107.354 31.3807 103.303L23.5376 70.6805L23.5375 70.6804C22.2702 65.4107 26.2359 60.3422 31.6145 60.3422H116.386C121.72 60.3422 125.664 65.329 124.493 70.551Z",
    fill: "white",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6874 98.6948C76.4158 98.6948 76.1442 98.5588 75.9358 98.2868C74.8436 96.8644 73.1441 96.8506 72.0642 98.2581C71.6436 98.8083 70.9664 98.8008 70.5505 98.2431C70.1355 97.6866 70.1402 96.7895 70.5618 96.2405C72.4509 93.7775 75.5359 93.7862 77.4391 96.2692C77.8598 96.8182 77.8654 97.7153 77.4504 98.2718C77.241 98.5525 76.9647 98.6948 76.6874 98.6948Z",
    fill: "#5A7FFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8819 87.0224C90.8819 89.134 89.1693 90.8476 87.0568 90.8476C84.9442 90.8476 83.2317 89.135 83.2317 87.0224C83.2317 84.9098 84.9442 83.1972 87.0568 83.1972C89.1693 83.1972 90.8819 84.9098 90.8819 87.0224Z",
    fill: "#5A7FFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3359 80.1858C94.1905 80.1858 94.0441 80.1593 93.9009 80.1041L85.0804 76.6895C84.4596 76.4487 84.1519 75.7515 84.3928 75.1308C84.6315 74.509 85.3297 74.2023 85.9515 74.4422L94.772 77.8567C95.3927 78.0976 95.7004 78.7947 95.4595 79.4154C95.2749 79.8929 94.8187 80.1858 94.337 80.1858H94.3359Z",
    fill: "#5A7FFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9547 88.5726C85.9547 89.1817 86.4481 89.6751 87.0571 89.6751C87.6661 89.6751 88.1595 89.1817 88.1595 88.5726C88.1595 87.9636 87.6661 87.4702 87.0571 87.4702C86.4481 87.4702 85.9547 87.9636 85.9547 88.5726Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7605 87.0224C56.7605 89.1339 58.4731 90.8476 60.5856 90.8476C62.6982 90.8476 64.4107 89.135 64.4107 87.0224C64.4107 84.9098 62.6982 83.1972 60.5856 83.1972C58.4731 83.1972 56.7605 84.9098 56.7605 87.0224Z",
    fill: "#5A7FFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3066 80.1859C52.8238 80.1859 52.3675 79.8931 52.184 79.4156C51.9431 78.7948 52.2519 78.0977 52.8715 77.8569L61.6921 74.4423C62.3138 74.2035 63.0109 74.5102 63.2507 75.1309C63.4916 75.7517 63.1828 76.4488 62.5632 76.6897L53.7427 80.1042C53.5994 80.1594 53.453 80.1859 53.3076 80.1859H53.3066Z",
    fill: "#5A7FFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7646 89.6518C61.3655 89.5543 61.7737 88.988 61.6761 88.387C61.5786 87.786 61.0123 87.3778 60.4113 87.4754C59.8103 87.573 59.4022 88.1392 59.4997 88.7403C59.5973 89.3413 60.1636 89.7494 60.7646 89.6518Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.348 117.349C129.381 111.315 129.381 101.533 123.348 95.5001C117.315 89.4668 107.533 89.4668 101.5 95.5001C95.4665 101.533 95.4665 111.315 101.5 117.349C107.533 123.382 117.315 123.382 123.348 117.349Z",
    fill: "url(#paint7_linear_3927_17261)",
    stroke: "#5A7FFF",
    strokeWidth: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.652 113.653C123.644 109.661 123.644 103.188 119.652 99.1959C115.66 95.2038 109.187 95.2038 105.195 99.1959C101.203 103.188 101.203 109.661 105.195 113.653C109.187 117.645 115.66 117.645 119.652 113.653Z",
    fill: "url(#paint8_linear_3927_17261)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.774 110.776C116.278 111.287 115.436 111.288 114.941 110.776L112.421 108.265L109.909 110.776C109.404 111.289 108.574 111.289 108.076 110.776C107.566 110.281 107.565 109.439 108.076 108.943L110.588 106.431L108.076 103.912C107.564 103.4 107.564 102.583 108.076 102.071C108.568 101.564 109.396 101.558 109.909 102.071L112.421 104.583L114.941 102.071C115.446 101.565 116.269 101.565 116.774 102.071C117.263 102.547 117.306 103.38 116.774 103.912L114.262 106.431L116.774 108.943C117.286 109.449 117.286 110.272 116.774 110.776Z",
    fill: "#5A7FFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3927_17261",
    x1: 30.5,
    y1: 28.5,
    x2: 91,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AABCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3927_17261",
    x1: 40.568,
    y1: 26,
    x2: 40.568,
    y2: 29.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3927_17261",
    x1: 27.5694,
    y1: 102,
    x2: 27.5694,
    y2: 105.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3927_17261",
    x1: 20.5694,
    y1: 87,
    x2: 20.5694,
    y2: 90.1265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3927_17261",
    x1: 22.4662,
    y1: 95,
    x2: 22.4662,
    y2: 99.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3927_17261",
    x1: 34.4638,
    y1: 31,
    x2: 34.4638,
    y2: 35.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E7F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3927_17261",
    x1: 73.8371,
    y1: 45.8811,
    x2: 73.8383,
    y2: 62.1605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1B3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3927_17261",
    x1: 101.712,
    y1: 95.7122,
    x2: 123.136,
    y2: 117.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9BCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3927_17261",
    x1: 105,
    y1: 99.5,
    x2: 120.5,
    y2: 113.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.e10b38e698e6b60b4f0175509af3b6c9.svg";
export { ForwardRef as ReactComponent };